<template>
    <div class="dbConfig">
        <div>
            <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
                <el-tab-pane v-for="(item, index) in menus" :key="index" :name="item.name" :label="item.label" />
            </el-tabs>
        </div>
        <div class="over-main">
            <!-- :include="['DbNavManage']" -->
            <router-view v-slot="{ Component }">
                <keep-alive>
                    <component :is="Component" />
                </keep-alive>
            </router-view>
            <!-- <router-view></router-view> -->
        </div>
    </div>
</template>

<script>

export default {
    name: 'DbNavManage',
    watch: {
        $route: {
            immediate: true,
            handler(newVal, oldVal) {
                this.act = newVal.path;
                const path = newVal.path;
                this.menus.forEach(item => {
                    if (path.endsWith(item.name)) {
                        this.activeName = item.name;
                    }
                })
            },
        }
    },
    data() {
        return {
            activeName: 'yearSetting',
            menus: [
                {
                    name: 'yearSetting',
                    label: '年份设置'
                },
            ]
        }
    },
    created() {

    },
    methods: {
        handleClick(tab, event) {
            console.log('tab, event: ', tab, event);
            // this.$router.push("/dbConfig/dbNavManage/" + tab.props.name)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.dbConfig {
    //padding: 20px;
}

::v-deep(.el-tabs__header) {
    margin: 0;
}
</style>